import React, { useState, useCallback } from 'react';
import { useScreenSize } from '../../../../../utils/media-query';
import { PopupForm } from '../../../../script/components/popup/popup';
import { FormExce } from '../../../../script/components/form/form-item';
import { GroupItem } from 'devextreme-react/cjs/form';
import { fwUtil } from '../../../../script/util';

const defaultData = {
    xlsx_save: null,    
}

export function StocAdjuRegiUpload(props) {
    const {
        refresh,
        uploadApi,
        visible, hiding
    } = props;

    const { isXSmall, isSmall } = useScreenSize();
    const [loading, setLoading] = useState(false);
    // 데이터
    const [data, setData] = useState(defaultData);
    const dataUpdate = useCallback((e) => setData(e), [setData]);

    // 닫힐 때
    const onHiding = useCallback(() => {
        dataUpdate(defaultData);
        hiding();
    }, [dataUpdate, hiding]);

    // 열릴 때
    const onShowing = useCallback(() => {
        dataUpdate(defaultData);
    }, [dataUpdate]);

    // 수정
    const updateField = (field) => (value) => {
        if (!data) return;

        dataUpdate({ ...data, [field]: value });
    };

    // 제출
    const onSubmit = useCallback(async () => {
        setLoading(true);
        const postData = new FormData();

        postData.append('xlsxSave', data.xlsx_save || null);

        await fwUtil.apis.action(uploadApi, postData, refresh, onHiding);
        setLoading(false);
    }, [data, uploadApi, refresh, onHiding]);

    return (
        <>  
        <PopupForm
            title={'재고조사표 업로드'}
            type={'등록'}
            loading={loading}
            visible={visible}
            showing={onShowing}
            hiding={onHiding}
            onSubmit={onSubmit}
            width={isXSmall || isSmall ? "100%" : 600}  
            warning={'좌측 재고조사표 메뉴에서 엑셀파일 다운로드 후 조정된 내용을 업로드해주세요!'}
        >
            <GroupItem colCount={isXSmall ? 1 : 2}>
                {FormExce({ value: data.xlsx_save, onValueChange: updateField('xlsx_save'), label: '재고 엑셀 파일' })}
            </GroupItem>
        </PopupForm>        
        </>
    );
}